/* ──────────────────────────────────────────────────────────────────────────
   NJM Chikki Upsell — one-tap cart order-bumps (Nut Just Milk)
   Offers: "Protein Chikki Pop — 4 Pack"   (hidden product, variant 47366414205059) ₹150 (was ₹200)
           "Superseed Chikki Pop — 4 Pack" (hidden product, variant 47414980608131) ₹185 (was ₹250)
   Both: pay for 3, get 1 free.
   Surfaces (2026-07-12): the Ella side-cart drawer AND the /cart page — same
   offer, one JS. Drawer zones: #njm-upsell-zone / -2. Cart-page zones:
   #njm-upsell-zone-cart / -2-cart (markup in sections/main-cart.liquid, under
   the items list). Qualifying subtotal ≥ QUALIFY_MIN shows the offer; below it
   the FIRST zone of each surface shows a "spend ₹X more" teaser.
   SAFE DESIGN: render() is DISPLAY-ONLY and NEVER mutates the cart — the only
   cart write is on the user's own tap of an add button. So it cannot loop.
   On the /cart page an add reloads the page (Ella's page cart list can't be
   re-rendered in place — same pattern as njm-icepack.js).
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__njmUpsellInit) return;
  window.__njmUpsellInit = true;

  var OFFERS = [
    // drawer
    { id: 47366414205059, zone: 'njm-upsell-zone',        title: 'njm-upsell-title',        msg: 'njm-upsell-msg',        btn: 'njm-upsell-add',
      name: '4 Protein Chikki Pops',   price: '₹150', each: '₹37 a pop', teaser: true },
    { id: 47414980608131, zone: 'njm-upsell-zone-2',      title: 'njm-upsell-title-2',      msg: 'njm-upsell-msg-2',      btn: 'njm-upsell-add-2',
      name: '4 Superseed Chikki Pops', price: '₹185', each: '₹46 a pop' },
    { id: 47634187714691, zone: 'njm-upsell-zone-3',      title: 'njm-upsell-title-3',      msg: 'njm-upsell-msg-3',      btn: 'njm-upsell-add-3',
      name: '5 Grab & Go Chivda packs', price: '₹349', each: '₹70 a pouch',
      blurb: 'Five single-serve 50 g pouches — one for the bag, one for the desk.',
      addedBlurb: 'Five 50 g pouches on the way · just ₹70 a pouch.' },
    { id: 47628468617347, zone: 'njm-upsell-zone-4',      title: 'njm-upsell-title-4',      msg: 'njm-upsell-msg-4',      btn: 'njm-upsell-add-4',
      name: '5 Everyday Chivda packs', price: '₹299', each: '₹60 a pouch',
      blurb: 'Five 50 g pouches of the original chivda — roasted, never fried.',
      addedBlurb: 'Five 50 g pouches on the way · just ₹60 a pouch.' },
    // cart page
    { id: 47366414205059, zone: 'njm-upsell-zone-cart',   title: 'njm-upsell-title-cart',   msg: 'njm-upsell-msg-cart',   btn: 'njm-upsell-add-cart',
      name: '4 Protein Chikki Pops',   price: '₹150', each: '₹37 a pop', teaser: true },
    { id: 47414980608131, zone: 'njm-upsell-zone-2-cart', title: 'njm-upsell-title-2-cart', msg: 'njm-upsell-msg-2-cart', btn: 'njm-upsell-add-2-cart',
      name: '4 Superseed Chikki Pops', price: '₹185', each: '₹46 a pop' },
    { id: 47634187714691, zone: 'njm-upsell-zone-3-cart', title: 'njm-upsell-title-3-cart', msg: 'njm-upsell-msg-3-cart', btn: 'njm-upsell-add-3-cart',
      name: '5 Grab & Go Chivda packs', price: '₹349', each: '₹70 a pouch',
      blurb: 'Five single-serve 50 g pouches — one for the bag, one for the desk.',
      addedBlurb: 'Five 50 g pouches on the way · just ₹70 a pouch.' },
    { id: 47628468617347, zone: 'njm-upsell-zone-4-cart', title: 'njm-upsell-title-4-cart', msg: 'njm-upsell-msg-4-cart', btn: 'njm-upsell-add-4-cart',
      name: '5 Everyday Chivda packs', price: '₹299', each: '₹60 a pouch',
      blurb: 'Five 50 g pouches of the original chivda — roasted, never fried.',
      addedBlurb: 'Five 50 g pouches on the way · just ₹60 a pouch.' },
  ];
  var OFFER_IDS = [47366414205059, 47414980608131, 47634187714691, 47628468617347];
  var ICE = 45813943107715;               // ice pack — excluded from qualifying total
  // 2026-07-20 (Vansh): was 299*100, which sat ABOVE a single milk (₹210) — so the most
  // common cart, and the one with the most room to grow, never saw an offer. Now any
  // non-empty qualifying cart gets the bumps. Empty carts still show nothing.
  var QUALIFY_MIN = 1;                    // ▼▼ TUNE ME ▼▼ paise

  var busy = false;

  function postJSON(url, body, tries) {
    tries = tries || 0;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) {
        if ((r.status === 429 || r.status >= 500) && tries < 4) {
          return new Promise(function (res) { setTimeout(res, 700 * (tries + 1)); }).then(function () { return postJSON(url, body, tries + 1); });
        }
        return r;
      });
  }
  function fetchCart(tries) {
    tries = tries || 0;
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) {
        if ((r.status === 429 || r.status >= 500) && tries < 4) {
          return new Promise(function (res) { setTimeout(res, 700 * (tries + 1)); }).then(function () { return fetchCart(tries + 1); });
        }
        return r.json();
      });
  }
  function rerender(cart) {
    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart(cart);
    }
  }
  function onCartPage() { return !!document.getElementById('njm-upsell-zone-cart'); }

  function qualifying(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      if (OFFER_IDS.indexOf(it.variant_id) !== -1 || it.variant_id === ICE) return;
      sum += it.line_price;
    });
    return sum;
  }
  function hasOffer(cart, id) { return (cart.items || []).some(function (it) { return it.variant_id === id; }); }

  // DISPLAY ONLY — never writes to the cart.
  function render(cart) {
    var q = qualifying(cart);
    OFFERS.forEach(function (o) {
      var z = document.getElementById(o.zone); if (!z) return;
      var title = document.getElementById(o.title);
      var msg = document.getElementById(o.msg);
      var add = document.getElementById(o.btn);
      var baseClass = z.className.indexOf('njm-upsell-zone--cart') !== -1 ? 'njm-upsell-zone njm-upsell-zone--cart' : 'njm-upsell-zone';

      if (!cart.items || !cart.items.length) { z.style.display = 'none'; return; }

      if (hasOffer(cart, o.id)) {
        z.style.display = '';
        z.className = baseClass + ' is-added';
        if (title) title.textContent = o.name + ' added 🎉';
        if (msg) msg.innerHTML = o.addedBlurb || ('Pay for 3, get 1 free · just ' + o.each + '.');
        if (add) add.style.display = 'none';
        return;
      }

      if (q >= QUALIFY_MIN) {
        z.style.display = '';
        z.className = baseClass;
        if (title) title.textContent = 'Add ' + o.name;
        if (msg) msg.innerHTML = o.blurb || 'Pay for 3, get 1 free — only with this order.';
        if (add) { add.style.display = ''; add.innerHTML = '＋&nbsp; Add to my order · ' + o.price; }
      } else if (o.teaser) {
        var away = Math.ceil((QUALIFY_MIN - q) / 100);
        z.style.display = '';
        z.className = baseClass + ' is-teaser';
        if (title) title.textContent = 'Unlock our Chikki Pop packs';
        if (msg) msg.innerHTML = 'Spend <strong>₹' + away + ' more</strong> to add 4-packs (pay for 3, get 1 free).';
        if (add) add.style.display = 'none';
      } else {
        z.style.display = 'none';
      }
    });
  }

  document.addEventListener('cart-update', function (e) {
    if (busy) { busy = false; return; }
    var cart = e && e.detail && e.detail.items ? e.detail : null;
    if (cart) render(cart); else fetchCart().then(render).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var offer = null;
    OFFERS.forEach(function (o) { if (e.target.closest('#' + o.btn)) offer = o; });
    if (!offer) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    setTimeout(function () { busy = false; }, 4000);
    postJSON('/cart/add.js', { items: [{ id: offer.id, quantity: 1 }] })
      .then(function () {
        if (onCartPage()) { location.reload(); return; }
        return fetchCart().then(function (cart) { rerender(cart); render(cart); });
      })
      .catch(function () { busy = false; });
  });

  // /cart page: re-evaluate when Ella re-renders the item rows (qty edits, removals).
  var clist = document.querySelector('.cart-list');
  if (clist && window.MutationObserver) {
    var deb;
    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(function () { fetchCart().then(render).catch(function () {}); }, 250);
    }).observe(clist, { childList: true });
  }

  function init() { fetchCart().then(render).catch(function () {}); }
  if (document.readyState !== 'loading') setTimeout(init, 450);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 450); });
})();
